import { Box, styled } from '@mui/material';

export const EntitySubsectionContent = styled(Box)({});
